var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        title: "Create Member",
        "header-bg-variant": "success",
        "header-text-variant": "light",
        size: "lg",
        visible: _vm.showModal,
        centered: ""
      },
      on: { hidden: _vm.reset },
      scopedSlots: _vm._u([
        {
          key: "modal-header-close",
          fn: function() {
            return [_c("h4", [_vm._v("X")])]
          },
          proxy: true
        }
      ])
    },
    [
      _vm._v(" "),
      _c(
        "b-form",
        [
          _c(
            "b-row",
            [
              _c(
                "h2",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.createOrgMembershipPending,
                      expression: "createOrgMembershipPending"
                    }
                  ],
                  staticClass: "u-padding-bottom-20"
                },
                [_vm._v("Updating, please wait ...")]
              ),
              _vm._v(" "),
              _c("pulse-loader", {
                attrs: {
                  loading: _vm.createOrgMembershipPending,
                  color: "#0F347B",
                  size: "50px"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-select",
            {
              attrs: {
                id: "userId",
                size: "lg",
                options: _vm.getUserList(_vm.userList)
              },
              model: {
                value: _vm.userId,
                callback: function($$v) {
                  _vm.userId = $$v
                },
                expression: "userId"
              }
            },
            [
              _c(
                "option",
                { attrs: { disabled: "" }, domProps: { value: null } },
                [_vm._v("-- Please select a user --")]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "b-form-checkbox",
            {
              staticClass: "m-3",
              attrs: {
                id: "isOrgAdmin",
                name: "isOrgAdmin",
                "unchecked-value": false,
                switch: "",
                inline: ""
              },
              model: {
                value: _vm.isOrgAdmin,
                callback: function($$v) {
                  _vm.isOrgAdmin = $$v
                },
                expression: "isOrgAdmin"
              }
            },
            [
              _vm._v(
                "\n      Organization Admin - Would you like this user to be able to share, unshare and transfer records on behalf of\n      your organization?\n    "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "b-form-checkbox",
            {
              staticClass: "m-3",
              attrs: {
                id: "isManager",
                name: "isManager",
                "unchecked-value": false,
                switch: "",
                inline: ""
              },
              model: {
                value: _vm.isManager,
                callback: function($$v) {
                  _vm.isManager = $$v
                },
                expression: "isManager"
              }
            },
            [
              _vm._v(
                "\n      Organization Manager - Would you like this user to be able to view all of the records for your organization?\n    "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "b-form-checkbox",
            {
              staticClass: "m-3",
              attrs: {
                id: "dwUser",
                name: "dwUser",
                "unchecked-value": false,
                switch: "",
                inline: ""
              },
              model: {
                value: _vm.isDWUser,
                callback: function($$v) {
                  _vm.isDWUser = $$v
                },
                expression: "isDWUser"
              }
            },
            [
              _vm._v(
                "\n        Data Warehouse User: Would you like this user to be able to access the Lighthouse Data Warehouse application?\n    "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "b-form-checkbox",
            {
              staticClass: "m-3",
              attrs: {
                id: "careCoordinator",
                name: "careCoordinator",
                "unchecked-value": false,
                switch: "",
                inline: ""
              },
              model: {
                value: _vm.isCareCoordinator,
                callback: function($$v) {
                  _vm.isCareCoordinator = $$v
                },
                expression: "isCareCoordinator"
              }
            },
            [
              _vm._v(
                "\n      Care Coordinator: Would you like this user to access the Victim Identification tab designed for care coordinators?\n    "
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-alert",
        {
          attrs: {
            fade: "",
            show:
              _vm.createOrgMembershipFailure ||
              _vm._.isObject(_vm.createOrgMembershipSuccess),
            variant: _vm.createOrgMembershipFailure ? "danger" : "success"
          }
        },
        [
          _c("span", {
            domProps: { innerHTML: _vm._s(_vm.apiResponseMessage()) }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "w-100",
          attrs: { slot: "modal-footer" },
          slot: "modal-footer"
        },
        [
          _c("span", { staticClass: "float-left text-danger" }, [
            _c("i", [
              _vm._v(
                "\n  Note: Inactive users will not appear in the select list! "
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "b-button",
            {
              staticClass: "float-right",
              attrs: { type: "button", variant: "primary", size: "sm" },
              on: { click: _vm.orgMemberHandler }
            },
            [_c("span", { staticClass: "button-text" }, [_vm._v("Create")])]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1f256b1f", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f256b1f","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/CreateOrganizationsMemberModal.vue
// module id = 1864
// module chunks = 0